module.exports = __webpack_public_path__ + "img/collectWhite.e751e6dc.svg";